import React, { useEffect, useRef, useState } from "react";
import { AuthService } from "../../services/sharedService/AuthService";
import UserImage from "../../components/UserImage/UserImage";
import getInitialsInName from "../../helper/GetNameInitials";
import Icons from "../../components/Icons/Icon";
import { useNavigate } from "react-router-dom";

type Props = {
  userProfile: any;
};

const PersonProfile: React.FC<Props> = ({ userProfile }) => {
  const authService = new AuthService();
  const [isUlVisible, setIsUlVisible] = useState(false);
  const dropdownRef = useRef<HTMLUListElement>(null);
  const navigate = useNavigate();

  const handleImageClick = () => {
    setIsUlVisible(!isUlVisible);
  };

  const logout = () => {
    authService.logout();
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsUlVisible(false);
    }
  };

  useEffect(() => {
    if (userProfile?.isDeleted == true || userProfile?.status == 0) {
      authService.logout();
      navigate("/");
    }
  }, [userProfile]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="absolute right-16 top-2/4 -translate-y-1/2">
      <div
        className="relative h-8 w-8 cursor-pointer rounded-full"
        onClick={handleImageClick}
      >
        {userProfile?.profileImagePath ? (
          <UserImage
            imgKey={userProfile.profileImagePath}
            className="w-full h-full object-cover rounded-full overflow-hidden"
          />
        ) : (
          <img
            src={getInitialsInName(userProfile?.name ?? "N A", 24)}
            alt={userProfile?.name}
            className="w-full h-full object-cover rounded-full overflow-hidden"
          />
        )}
        {isUlVisible && (
          <ul
            ref={dropdownRef}
            className="absolute -right-5 top-[2.25rem] z-[9999] w-[9.25rem] rounded-md shadow-300 border border-gray-400"
          >
            <li
              className="bg-white flex justify-start items-center gap-1 text-300 px-3 py-2 relative font-medium text-gray-300 hover:bg-gray-200 cursor-pointer border-b last:border-0 border-gray-400 w-full last:rounded-b-md"
              onClick={() => {
                const link = document.createElement("a");
                link.href = "/setup/iOS.dmg";
                link.download = "iOS.dmg";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <Icons name="mac" variant="stroke" size={16} />
              <span className="line-clamp-1">Companion App</span>
            </li>
            <li
              className="bg-white flex justify-start items-center gap-1 text-300 px-3 py-2 relative font-medium text-gray-300 hover:bg-gray-200 cursor-pointer border-b last:border-0 border-gray-400 w-full last:rounded-b-md"
              onClick={() => {
                const link = document.createElement("a");
                link.href = "/setup/windows.exe";
                link.download = "windows.exe";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              <Icons name="windwos" variant="stroke" size={16} />
              <span className="line-clamp-1">Companion App</span>
            </li>
            <li
              className="bg-white flex justify-start items-center gap-1 text-300 px-3 py-2 relative font-medium text-gray-300 hover:bg-gray-200 cursor-pointer border-b last:border-0 border-gray-400 w-full last:rounded-b-md"
              onClick={logout}
            >
              <Icons name="logout" variant="stroke" size={16} />
              <span className="line-clamp-1">Log Out</span>
            </li>
          </ul>
        )}
        <span className="absolute -right-5 top-1/2 -translate-y-2/4">
          <Icons name="down" variant="arrow" size={14} />
        </span>
      </div>
    </div>
  );
};

export default PersonProfile;
